import { STATUS_FIELD } from "modules/swiftboard/components/advance-filter";
import { DATA_TYPE_LABEL, FIELD_ROLE_LABEL, toOptions } from "../../../features/builder.constants";

// Advanced filter of the field grid. Every key must also be in FILTER_FIELDS of the backend's
// reminder_setup/source_field/controller.js, the whitelist get-all filters on.
export const sourceFieldFilterFields = [
  { key: "field_role", label: "Role", type: "enum", group: "Details", options: toOptions(FIELD_ROLE_LABEL) },
  { key: "data_type", label: "Data type", type: "enum", group: "Details", options: toOptions(DATA_TYPE_LABEL) },
  { key: "is_filterable", label: "Can be filtered", type: "boolean", group: "Details" },
  { key: "is_template_var", label: "Template variable", type: "boolean", group: "Details" },
  { key: "is_sensitive", label: "Sensitive", type: "boolean", group: "Details" },
  { ...STATUS_FIELD, group: "Details" },
];
